import Config from "../Config";
import StateGlobal from "../StateGlobal";
import MetamodelStore from "../resources/data/MetamodelStore";

/**
 * Inserting tags to word document
 */
export default class WordInsertions
{
    static aDelimiters = {
        sStart: '{#',
        sEnd: '#}'
    };
    /**
     * Insert loop through models. All or specific if aParams.sName passed.
     * @param {Object} aParams 
     * @param {Object} context 
     */
    static modelLoop = (aParams, context) =>
    {
        if (aParams && Object.hasOwnProperty.call(aParams, 'sName'))
        {
            WordInsertions.insertText(WordInsertions.aDelimiters.sStart + "FOR element in modelType(models, '" + aParams.sName + "')" + WordInsertions.aDelimiters.sEnd + "\n\n" + WordInsertions.aDelimiters.sStart + "END-FOR element" + WordInsertions.aDelimiters.sEnd);
        }
        else
        {
            WordInsertions.insertText(WordInsertions.aDelimiters.sStart + "FOR element in models" + WordInsertions.aDelimiters.sEnd + "\n\n" + WordInsertions.aDelimiters.sStart + "END-FOR element" + WordInsertions.aDelimiters.sEnd)
        }
    }

    /**
     * Insert loop through objects. All or specific if aParams.sName passed.
     * @param {Object} aParams 
     * @param {Object} context 
     */
    static objectLoop = (aParams, context) =>
    {
        if (aParams && Object.hasOwnProperty.call(aParams, 'sName'))
        {
            WordInsertions.insertText(WordInsertions.aDelimiters.sStart + "FOR element in objType(objects, '" + aParams.sName + "')" + WordInsertions.aDelimiters.sEnd + "\n\n" + WordInsertions.aDelimiters.sStart + "END-FOR element" + WordInsertions.aDelimiters.sEnd);
        }
        else
        {
            WordInsertions.insertText(WordInsertions.aDelimiters.sStart + "FOR element in objects" + WordInsertions.aDelimiters.sEnd + "\n\n" + WordInsertions.aDelimiters.sStart + "END-FOR element" + WordInsertions.aDelimiters.sEnd)
        }
    }

    /**
     * Insert loop through model's selected objects
     * Must be inserted inside main loop
     * @param {Object} aParams 
     * @param {Object} context 
     */
    static modelObjLoop = (aParams, context) =>
    {
        WordInsertions.insertText(WordInsertions.aDelimiters.sStart + "FOR elemModelObj in modelObjType("+Config.getBreadcrumbsLvl()+", ['" + aParams.join("','") + "'])" + WordInsertions.aDelimiters.sEnd + "\n\n" + WordInsertions.aDelimiters.sStart + "END-FOR elemModelObj" + WordInsertions.aDelimiters.sEnd);
    }

    /**
     * Insert model image
     * Must be inserted inside main loop
     */
    static modelImage = () =>
    {
        WordInsertions.insertText(
            WordInsertions.aDelimiters.sStart +
            "IMAGE modelImg("+Config.getBreadcrumbsLvl()+", {maxWidth: 16, maxHeight: 25})" +
            WordInsertions.aDelimiters.sEnd,
            "After"
        ); // the second parameter is max image size [cm]
    }

    /**
     * Insert property data
     * Must be inserted inside main loop, or even inside inner loop through object
     * @param {Object} aParams 
     * @param {Object} context 
     */
    static propertyData = (aParams, context) =>
    {
        const bCheckDefined = (
            (aParams.hasOwnProperty("sName") && aParams.sName === "NAME") &&
            (aParams.hasOwnProperty("sType") || aParams.sType !== "REL") &&
            (aParams.hasOwnProperty("sData") && aParams.sData === "value")
        );

        const aAttrInfo = MetamodelStore.getInstance().getMetaAttributeByLangIndependent(aParams.sName);
        const bIsFilePointer = aAttrInfo?.attrtype?.sName === "FILE_POINTER";
        const isMultiLine = aParams.ctrlType === "STRING_MULTILINE";

        var sIntructionString = 'attr';
        var sDataString = 'Name';
        if (aParams && Object.hasOwnProperty.call(aParams, 'sType') && 'REL' === aParams.sType)
        {
            sIntructionString = 'rel';
        }
        if (aParams && Object.hasOwnProperty.call(aParams, 'sData') && 'value' === aParams.sData)
        {
            sDataString = 'Val';
        }
        var sCommand = sIntructionString.concat(sDataString);

        const sCheckStringEnd = " : ''";
        const sCheckStringBegin = ["(typeof "+Config.getBreadcrumbsLvl()+" !== 'undefined'", ") ? "];
        const bIsLink = bIsFilePointer && 'value' === aParams.sData;
        
        if(aParams.listMode === true){
           
            const currentLvl = StateGlobal._currentBradCrumbs.length;
            const sRelationName = aParams.sName;
            const sDirection = aParams.direction;
            const namesArrayString = "[]";

            const startDelimiter = WordInsertions.aDelimiters.sStart;
            const endDelimiter = WordInsertions.aDelimiters.sEnd;
            const levelVar = `list`;

            const artefactCall = (currentLvl === 0) ? `lists($element, '${sRelationName}:${sDirection}', ${namesArrayString})` : `lists($lvl_${currentLvl}, '${sRelationName}:${sDirection}', ${namesArrayString})`;
            const attributeCall = `attrVal($list, 'NAME')`;

            // Construct the text step-by-step
            const loopStart = `${startDelimiter}FOR ${levelVar} in ${artefactCall}${endDelimiter}`;
            const attributeFetch = `${startDelimiter}${attributeCall}${endDelimiter}`;
            const loopEnd = `${startDelimiter}END-FOR ${levelVar}${endDelimiter}`;

            // Combine all parts into the final text with \n included
            const finalText = `${loopStart}\n${attributeFetch}\n${loopEnd}\n`;

            // Insert the constructed text
            WordInsertions.insertText(finalText);


        }
        else if (!aParams.isInnerLoop)
        {
            
            const sCheckStringStart = sCheckStringBegin.join("");
            
            WordInsertions.insertText(
                WordInsertions.aDelimiters.sStart +
                (bIsLink ? "HTML " : "") +
                (bCheckDefined ? sCheckStringStart : "") +
                sCommand +
                "("+Config.getBreadcrumbsLvl()+", '" + aParams.sName+(aParams.direction ? ':'+aParams.direction : "") + "'" + (bIsLink ? ", null, 'link'" : "") + ")" +
                (bCheckDefined ? sCheckStringEnd : "") +
                WordInsertions.aDelimiters.sEnd,
                "After"
            );
        }
        else
        {
            const sCheckStringStart = sCheckStringBegin[0].concat(" && typeof $elemModelObj !== 'undefined'", sCheckStringBegin[1]);

            WordInsertions.insertText(
                WordInsertions.aDelimiters.sStart +
                (bIsLink ? "HTML " : "") +
                (bCheckDefined ? sCheckStringStart : "") +
                sCommand +
                "("+Config.getBreadcrumbsLvl()+", '" + aParams.sName + "', $elemModelObj" + (bIsLink ? ", 'link'" : "") + ")" +
                (bCheckDefined ? sCheckStringEnd : "") +
                WordInsertions.aDelimiters.sEnd,
                "After"
            );
        }
    }

    static _prepareRelationData = (aParams, bPreventLink) =>
    {
        var sBaseString = "rel";
        var sIntructionString = 'Attr';
        var sDataString = 'Name';
        const aAttrInfo = MetamodelStore.getInstance().getMetaAttributeByLangIndependent(aParams.sName);
        const bIsFilePointer = aAttrInfo?.attrtype?.sName === "FILE_POINTER";

        if (aParams && aParams.hasOwnProperty('sType') && 'REL' === aParams.sType)
        {
            sIntructionString = 'Rel';
        }
        if (aParams && aParams.hasOwnProperty('sData') && 'value' === aParams.sData)
        {
            sDataString = 'Val';
        }
        var sCommand = sBaseString.concat(sIntructionString, sDataString);

        let sDirection = aParams.direction;

        let sStringToInsert = null;
        const bIsLink = bIsFilePointer && !bPreventLink && 'value' === aParams.sData;

        if (!aParams.isInnerLoop) {
            if(aParams.oldUI) {
                sStringToInsert = WordInsertions.aDelimiters.sStart +
                (bIsLink ? "HTML " : "") +
                sCommand +
                "("+"$element"+", null, '" + aParams.relName + "', '" + sDirection + "', " + (aParams.isTarget ? "'TARGET', '" : "null, '") + aParams.sName + "'" + (bIsLink ? ", 'link'" : "") + ")" +
                WordInsertions.aDelimiters.sEnd, "After";

                return sStringToInsert;
            }
        }else{
            if(aParams.oldUI) {
                sStringToInsert = WordInsertions.aDelimiters.sStart +
                (bIsLink ? "HTML " : "") +
                sCommand +
                "("+"$element"+", $elemModelObj, '" + aParams.relName + "', '" + sDirection + "', " + (aParams.isTarget ? "'TARGET', '" : "null, '") + aParams.sName + "'" + (bIsLink ? ", 'link'" : "") + ")" +
                WordInsertions.aDelimiters.sEnd, "After";

                return sStringToInsert;
            }
        }
        
        if (!aParams.isInnerLoop)
        {
            sStringToInsert =
                WordInsertions.aDelimiters.sStart +
                (bIsLink ? "HTML " : "") +
                sCommand +
                "("+Config.getBreadcrumbsLvl()+", null, '" + aParams.relName + "', '" + sDirection + "', " + (aParams.isTarget ? "'TARGET', '" : "null, '") + aParams.sName + "'" + (bIsLink ? ", 'link'" : "") + ")" +
                WordInsertions.aDelimiters.sEnd, "After";
        }
        else
        {
            sStringToInsert =
                WordInsertions.aDelimiters.sStart +
                (bIsLink ? "HTML " : "") +
                sCommand +
                "("+Config.getBreadcrumbsLvl()+", $elemModelObj, '" + aParams.relName + "', '" + sDirection + "', " + (aParams.isTarget ? "'TARGET', '" : "null, '") + aParams.sName + "'" + (bIsLink ? ", 'link'" : "") + ")" +
                WordInsertions.aDelimiters.sEnd, "After";
        }
        return sStringToInsert;
    }
    static _prepareRelationPairData = (aParams) =>
    {
        const sCommand = "relPairVal";

        const sRelData = {
            type: (aParams.relationAttr.type === "REL") ? "rel" : "attr",
            attr: aParams.relationAttr.attr
        };
        const sTrgData = {
            type: (aParams.targetAttr.type === "REL") ? "rel" : "attr",
            attr: aParams.targetAttr.attr
        };

        const sRelInsertion = "{type: '" + sRelData.type + "', attr: '" + sRelData.attr + "'}"
        const sTrgInsertion = "{type: '" + sTrgData.type + "', attr: '" + sTrgData.attr + "'}"

        let aAdditionalStringsArr = ["", "", ""];
        let sAdditionalStrings = "";
        if (aParams.additionalStrings.hasOwnProperty("prefix") && aParams.additionalStrings.prefix)
        {
            aAdditionalStringsArr[0] = aParams.additionalStrings.prefix;
        }
        if (aParams.additionalStrings.hasOwnProperty("separator") && aParams.additionalStrings.separator)
        {
            aAdditionalStringsArr[1] = aParams.additionalStrings.separator;
        }
        if (aParams.additionalStrings.hasOwnProperty("sufix") && aParams.additionalStrings.sufix)
        {
            aAdditionalStringsArr[2] = aParams.additionalStrings.sufix;
        }
        sAdditionalStrings = "'" + aAdditionalStringsArr.join("', '") + "'";

        let sStringToInsert = null;
        if (!aParams.isInnerLoop)
        {
            sStringToInsert =
                WordInsertions.aDelimiters.sStart +
                sCommand +
                "("+Config.getBreadcrumbsLvl()+", null, '" + aParams.relName + "', '" + aParams.direction + "', " + sRelInsertion + ", " + sTrgInsertion + ", " + sAdditionalStrings + ")" +
                WordInsertions.aDelimiters.sEnd, "After";
        }
        else
        {
            sStringToInsert =
                WordInsertions.aDelimiters.sStart +
                sCommand +
                "("+Config.getBreadcrumbsLvl()+", $elemModelObj, '" + aParams.relName + "', '" + aParams.direction + "', " + sRelInsertion + ", " + sTrgInsertion + ", " + sAdditionalStrings + ")" +
                WordInsertions.aDelimiters.sEnd, "After";
        }
        return sStringToInsert;
    }

    static relationData = (aParams) =>
    {
        const sStringToInsert = WordInsertions._prepareRelationData(aParams);
        if (sStringToInsert)
        {
            WordInsertions.insertText(sStringToInsert);
        }
    }

    static _removeDelimiters = (sPhrase) =>
    {
        let sPhraseMod = sPhrase;
        if (sPhraseMod.startsWith(WordInsertions.aDelimiters.sStart))
        {
            sPhraseMod = sPhraseMod.slice(WordInsertions.aDelimiters.sStart.length);
        }
        if (sPhraseMod.endsWith(WordInsertions.aDelimiters.sEnd))
        {
            sPhraseMod = sPhraseMod.slice(0, sPhraseMod.length - WordInsertions.aDelimiters.sEnd.length);
        }
        return sPhraseMod;
    }

    /**
     * Insert table with model's/object's properties
     * Must be inserted inside main loop, or even inside inner loop through object
     * @param {Array} aTableData 
     */
    static insertAttrTable = (aTableData, bNoValueAllow) =>
    {
        var aTable = [];
        for (var i = 0; i < aTableData.length; i++)
        {
            var aTableItem = [];
            var sNameFunc = '';
            var sValFunc = '';
            var sTableItemNoLink = '';
            var bIsModelObj = false;
            var sIntructionString = 'attr';
            if (aTableData[i] && Object.hasOwnProperty.call(aTableData[i], 'extra'))
            {
                if (Object.hasOwnProperty.call(aTableData[i].extra, 'bIsModelObj') && aTableData[i].extra.bIsModelObj)
                {
                    bIsModelObj = true;
                }
                if (Object.hasOwnProperty.call(aTableData[i].extra, 'sType') && 'REL' === aTableData[i].extra.sType)
                {
                    sIntructionString = 'rel';
                }

                let sName = aTableData[i].name;
                if (aTableData[i].name.includes("#"))
                {
                    let aNameSplitted = aTableData[i].name.split("#");
                    sName = aNameSplitted[0];
                    if (!sName)
                    {
                        break;
                    }
                }
                let sValFuncNoLink = '';

                if (aTableData[i].hasOwnProperty("extra") && aTableData[i].extra.hasOwnProperty("relation"))
                {
                    aTableItem[0] = WordInsertions._prepareRelationData(
                    {
                        sName: sName,
                        sType: aTableData[i].extra.sType,
                        sData: 'name',
                        direction: aTableData[i].extra.direction,
                        isTarget: aTableData[i].extra.isTarget,
                        isInnerLoop: bIsModelObj,
                        relName: aTableData[i].extra.relation
                    });
                    if (aTableData[i].hasOwnProperty("extra") && aTableData[i].extra.hasOwnProperty("relationLang") && aTableData[i].extra.relationLang)
                    {

                        aTableItem[0] = aTableItem[0].concat(" (", aTableData[i].extra.relationLang);
                        if (aTableData[i].extra.hasOwnProperty("isTarget") && aTableData[i].extra.isTarget)
                        {
                            aTableItem[0] = aTableItem[0].concat(", ", Config.strings.modals.modelObj.nestedTarget, ")");
                        }
                        else
                        {
                            aTableItem[0] = aTableItem[0].concat(")");
                        }
                    }

                    aTableItem[1] = WordInsertions._prepareRelationData(
                    {
                        sName: sName,
                        sType: aTableData[i].extra.sType,
                        sData: 'value',
                        direction: aTableData[i].extra.direction,
                        isTarget: aTableData[i].extra.isTarget,
                        isInnerLoop: bIsModelObj,
                        relName: aTableData[i].extra.relation
                    });
                    sTableItemNoLink = WordInsertions._prepareRelationData(
                    {
                        sName: sName,
                        sType: aTableData[i].extra.sType,
                        sData: 'value',
                        direction: aTableData[i].extra.direction,
                        isTarget: aTableData[i].extra.isTarget,
                        isInnerLoop: bIsModelObj,
                        relName: aTableData[i].extra.relation
                    }, true);
                }
                else
                {
                    const aAttrInfo = MetamodelStore.getInstance().getMetaAttributeByLangIndependent(aTableData[i]?.name);
                    const bIsFilePointer = aAttrInfo?.attrtype?.sName === "FILE_POINTER";
                    
                    if (bIsModelObj)
                    {
                        sNameFunc = sIntructionString + "Name("+Config.getBreadcrumbsLvl()+", '" + sName + "', $elemModelObj)";
                        sValFunc = sIntructionString + "Val("+Config.getBreadcrumbsLvl()+", '" + sName + (aTableData[i].extra.direction ? ":"+aTableData[i].extra.direction : "") + "', $elemModelObj" + (bIsFilePointer ? ", 'link'" : "") + ")";
                        sValFuncNoLink = sIntructionString + "Val("+Config.getBreadcrumbsLvl()+", '" + sName + "', $elemModelObj" + ")";
                    }
                    else
                    {
                        sNameFunc = sIntructionString + "Name("+Config.getBreadcrumbsLvl()+", '" + sName + "')";
                        sValFunc = sIntructionString + "Val("+Config.getBreadcrumbsLvl()+", '" + sName+ (aTableData[i].extra.direction ? ":"+aTableData[i].extra.direction : "") + "'" + (bIsFilePointer ? ", null, 'link'" : "") + ")";
                        sValFuncNoLink = sIntructionString + "Val("+Config.getBreadcrumbsLvl()+", '" + sName + "'" + ")";
                    }
                    var forList = "";
                    if(aTableData[i].extra.list === true){

                        const currentLvl = StateGlobal._currentBradCrumbs.length;
                        const sRelationName = aTableData[i].name;
                        const sDirection = aTableData[i].extra?.direction || "";
                        const namesArrayString = "[]";

                        const startDelimiter = WordInsertions.aDelimiters.sStart;
                        const endDelimiter = WordInsertions.aDelimiters.sEnd;
                        const levelVar = `list`;
                        const artefactCall = `lists($element, '${sRelationName}:${sDirection}', ${namesArrayString})`;
                        const attributeCall = `attrVal($list, 'NAME')`;

                        // Construct the text step-by-step
                        const loopStart = `${startDelimiter}FOR ${levelVar} in ${artefactCall}${endDelimiter}`;
                        const attributeFetch = `${startDelimiter}${attributeCall}${endDelimiter}`;
                        const loopEnd = `${startDelimiter}END-FOR ${levelVar}${endDelimiter}`;

                        // Combine all parts into the final text with \n included
                        const finalText = `${loopStart}\n${attributeFetch}\n${loopEnd}\n`;

                        aTableItem[0] = WordInsertions.aDelimiters.sStart + sNameFunc + WordInsertions.aDelimiters.sEnd;
                        aTableItem[1] = finalText
                        forList = WordInsertions.aDelimiters.sStart + (bIsFilePointer ? "HTML " : "") + sValFunc + WordInsertions.aDelimiters.sEnd;
                        sTableItemNoLink = bIsFilePointer ? WordInsertions.aDelimiters.sStart + sValFuncNoLink + WordInsertions.aDelimiters.sEnd : null;
                    }else{
                        aTableItem[0] = WordInsertions.aDelimiters.sStart + sNameFunc + WordInsertions.aDelimiters.sEnd;
                        aTableItem[1] = WordInsertions.aDelimiters.sStart + (bIsFilePointer ? "HTML " : "") + sValFunc + WordInsertions.aDelimiters.sEnd;
                        forList = WordInsertions.aDelimiters.sStart + (bIsFilePointer ? "HTML " : "") + sValFunc + WordInsertions.aDelimiters.sEnd;
                        // aTableItem[2] = WordInsertions.aDelimiters.sStart + (bIsFilePointer ? "HTML " : "") + sValFunc + WordInsertions.aDelimiters.sEnd;
                        sTableItemNoLink = bIsFilePointer ? WordInsertions.aDelimiters.sStart + sValFuncNoLink + WordInsertions.aDelimiters.sEnd : null;
                    }
                }
            }
            if (0 < aTableItem.length)
            {
                if (!bNoValueAllow)
                {
                    if(aTableData[i].extra.list === true){
                        aTable.push([
                            WordInsertions.aDelimiters.sStart + "IF " + WordInsertions._removeDelimiters(sTableItemNoLink ? sTableItemNoLink : forList) + WordInsertions.aDelimiters.sEnd,
                            ''
                        ]);
                    }else{
                        aTable.push([
                            WordInsertions.aDelimiters.sStart + "IF " + WordInsertions._removeDelimiters(sTableItemNoLink ? sTableItemNoLink : forList) + WordInsertions.aDelimiters.sEnd,
                            ''
                        ]);
                    }
                    
                }
                aTable.push(aTableItem);
                if (!bNoValueAllow)
                {
                    aTable.push([
                        WordInsertions.aDelimiters.sStart + "END-IF" + WordInsertions.aDelimiters.sEnd,
                        ''
                    ]);
                }
            }
        }

        if (0 < aTable.length)
        {
            WordInsertions.insertTable(aTable, 'After');
        }
        else
        {
            console.warn("No correct data to create a table")
        }
    }

    /**
     * Insert table with model's objects and their properties
     * Must be inserted inside main loop
     * @param {Array} aObjList 
     * @param {Array} aAttrList 
     */
    static insertModalObjAttr = (aObjList, aAttrList, sOrderBy) =>
    {
        Config.getConfig();
        var aTable = []; // table data to return
        var aTableHeaders = []; // headers data
        var aTablePartDynamic = []; // table content

        const getWordInsertion = (aAttrListItem) =>
        {
            var sIntructionString = "attr";
            var bIsModelObj = false;
            if (Object.hasOwnProperty.call(aAttrListItem, 'extra') && Object.hasOwnProperty.call(aAttrListItem.extra, 'sType') && 'REL' === aAttrListItem.extra.sType)
            {
                sIntructionString = "rel"
            }
            if (Object.hasOwnProperty.call(aAttrListItem, 'extra') && Object.hasOwnProperty.call(aAttrListItem.extra, 'bIsModelObj'))
            {
                bIsModelObj = aAttrListItem.extra.bIsModelObj;
            }

            var sValue = '';
            var sHeader = '';
            try
            {
                let sName = aAttrListItem.name;
                if (aAttrListItem.name.includes("#"))
                {
                    let aNameSplitted = aAttrListItem.name.split("#");
                    sName = aNameSplitted[0];
                    if (!sName)
                    {
                        return null;
                    }
                }
                const aPropertyData = MetamodelStore.getInstance().getMetaPropertyByLangIndependent(sName);
                let aPropertyNameLangDependent = Config.getLangName(aPropertyData);
                if (aAttrListItem.hasOwnProperty("extra") && aAttrListItem.extra.hasOwnProperty("relationLang") && aAttrListItem.extra.relationLang)
                {
                    aPropertyNameLangDependent = aPropertyNameLangDependent.concat(" (", aAttrListItem.extra.relationLang);
                    if (aAttrListItem.extra.hasOwnProperty("isTarget") && aAttrListItem.extra.isTarget)
                    {
                        aPropertyNameLangDependent = aPropertyNameLangDependent.concat(", ", Config.strings.modals.modelObj.nestedTarget, ")");
                    }
                    else
                    {
                        aPropertyNameLangDependent = aPropertyNameLangDependent.concat(")");
                    }
                }

                if (aAttrListItem.hasOwnProperty("extra") && aAttrListItem.extra.hasOwnProperty("relation"))
                {
                    sValue = WordInsertions._prepareRelationData(
                    {
                        sName: sName,
                        sType: aAttrListItem.extra.sType,
                        sData: 'value',
                        direction: aAttrListItem.extra.direction,
                        isTarget: aAttrListItem.extra.isTarget,
                        isInnerLoop: bIsModelObj,
                        relName: aAttrListItem.extra.relation
                    });
                }
                else
                {
                    if(aAttrListItem.extra?.ctrlType === "STRING_MULTILINE"){
                        sValue = ""+WordInsertions.aDelimiters.sStart + "" + sIntructionString + "Val("+Config.getBreadcrumbsLvl()+", '" + sName + "'" + (bIsModelObj ? ", $elemModelObj)" + WordInsertions.aDelimiters.sEnd : ")" + WordInsertions.aDelimiters.sEnd);
                    }else{
                        sValue = ""+WordInsertions.aDelimiters.sStart + "" + sIntructionString + "Val("+Config.getBreadcrumbsLvl()+", '" + sName + "'" + (bIsModelObj ? ", $elemModelObj)" + WordInsertions.aDelimiters.sEnd : ")" + WordInsertions.aDelimiters.sEnd);
                    }
                }
                sHeader = aPropertyNameLangDependent;
                return {
                    header: sHeader,
                    value: sValue
                };
            }
            catch (err)
            {
                console.error(err);
            }
        }

        const getWordInsertionPair = (aAttrListItem) =>
        {
            let aRelation = MetamodelStore.getInstance().getMetaPropertyByLangIndependent(aAttrListItem.relation);
            let sHeaderLabel = Config.getLangName(aRelation);
            const aRelObj = aAttrListItem.attrs.find(aAttr =>
            {
                return !(aAttr.hasOwnProperty("extra") && aAttr.extra.isTarget);
            });
            const aTrgObj = aAttrListItem.attrs.find(aAttr =>
            {
                return (aAttr.hasOwnProperty("extra") && aAttr.extra.isTarget);
            });
            let aRelAttrMeta = MetamodelStore.getInstance().getMetaPropertyByLangIndependent(aRelObj.name);
            let aTrgAttrMeta = MetamodelStore.getInstance().getMetaPropertyByLangIndependent(aTrgObj.name);

            if (!aAttrListItem.attrs[0].hasOwnProperty("extra") || !aAttrListItem.attrs[1].hasOwnProperty("extra"))
            {
                return null;
            }
            const aInsertionValue = WordInsertions._prepareRelationPairData(
            {
                isInnerLoop: (aAttrListItem.attrs[0].extra.hasOwnProperty("bIsModelObj") && aAttrListItem.attrs[0].extra.bIsModelObj),
                relName: aAttrListItem.relation,
                direction: aAttrListItem.attrs[0].extra.direction,
                relationAttr:
                {
                    type: aRelObj.extra.sType,
                    attr: aRelObj.name
                },
                targetAttr:
                {
                    type: aTrgObj.extra.sType,
                    attr: aTrgObj.name
                },
                additionalStrings: Config.strings.wordInsertions.pairModeAdditionalStrings
            });
            let sDirectionLabel = (aAttrListItem.attrs[0].extra.hasOwnProperty("direction") && aAttrListItem.attrs[0].extra.direction === "INCOMING") ?
                Config.strings.wordInsertions.sourceLabel :
                Config.strings.wordInsertions.targetLabel;
            const aInsertionHeader = sHeaderLabel.concat(
                " (", Config.getLangName(aRelAttrMeta), "): ",
                sDirectionLabel, " (", Config.getLangName(aTrgAttrMeta), ")"
            );

            return {
                value: aInsertionValue,
                header: aInsertionHeader
            };
        }

        for (var i = 0; i < aAttrList.length; i++)
        {
            let aInsertion;
            if (aAttrList[i].isPair)
            {
                aInsertion = getWordInsertionPair(aAttrList[i]);
            }
            else
            {
                aInsertion = getWordInsertion(aAttrList[i]);
            }
            if (!aInsertion)
            {
                break;
            }
            aTablePartDynamic.push(aInsertion.value);
            aTableHeaders.push(aInsertion.header);
        }
        aTable = [
            aTableHeaders,
            [WordInsertions.aDelimiters.sStart + "FOR elemModelObj in modelObjType("+Config.getBreadcrumbsLvl()+", ['" + aObjList.join("','") + "']" + (sOrderBy ? (", '" + sOrderBy + "'") : "") + ")" + WordInsertions.aDelimiters.sEnd],
            aTablePartDynamic,
            [WordInsertions.aDelimiters.sStart + "END-FOR elemModelObj" + WordInsertions.aDelimiters.sEnd]
        ];
        if (0 < aTable.length)
        {
            WordInsertions.insertTable(aTable, 'After', aTablePartDynamic.length);
        }
        else
        {
            console.warn("No correct data to create a table")
        }
    }

    /**
     * Insert text into Word document
     * @param {String} sText 
     * @param {String} sPosition 
     */
    static insertText = async (sText, sPosition) =>
    {
        if (!typeof sText === 'string')
        {
            console.error("Provided data is not a string");
            return;
        }

        await Word.run(async (context) =>
        {
            let selectionRange = context.document.getSelection();
            selectionRange.insertText(sText, sPosition);
            await context.sync();
        });
    }

    /**
     * Insert table to Word document
     * @param {Array} aTable 
     * @param {String} sPosition 
     * @param {Number} nCols 
     * @param {Number} nRows 
     */
    static insertTable = async (aTable, sPosition, nCols, nRows) =>
    {
        var nColsNr = nCols;
        var nRowsNr = nRows;
        if (typeof aTable != 'object' || !Object.hasOwnProperty.call(aTable, 'length') ||
            typeof aTable[0] != 'object' || !Object.hasOwnProperty.call(aTable[0], 'length'))
        {
            console.error("Provided data not correct table data");
            return;
        }

        if (!nColsNr)
        {
            nColsNr = aTable[0].length;
        }
        if (!nRowsNr)
        {
            nRowsNr = aTable.length;
        }

        await Word.run(async (context) =>
        {
            let selectionRange = context.document.getSelection();
            selectionRange.insertTable(nRowsNr, nColsNr, sPosition, aTable);
            await context.sync();
        });
    }
}